import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import Downshift from 'downshift';
import { Text } from '@custom-components';
import { InputAdornment, MenuItem, Paper } from '@mui/material';
import FormElements from '../FormElements/FormElements';
import { LoadingSuggestion } from './Suggestions';

function createSuggestionLabel(suggestion, filterProps) {
  if (!suggestion) return '';

  const singleLabel = suggestion[filterProps[0]] || '';
  return singleLabel;
}

function RenderMenuSuggestion(onClickItem, filterProps, suggestion, closeMenu, setState, i) {
  return (
    <MenuItem
      key={`menu-item-${i}`}
      onClick={(e) => {
        setState({ inputValue: e.currentTarget.textContent });
        onClickItem(e.currentTarget.textContent);
        closeMenu();
      }}
    >
      <Text.CopyBody noMargins>{createSuggestionLabel(suggestion, filterProps)}</Text.CopyBody>
    </MenuItem>
  );
}

function GooglePlacesAutoComplete(props) {
  const {
    loading,
    label,
    placeholder,
    variant,
    onInputChange,
    suggestions,
    filterProps,
    onClickItem,
    value,
    styledProps
  } = props;
  const [searchValue, setSearchValue] = useState(value);

  // This effect handles clearing the DownShift inputValue prop when the advanced search form is reset
  useEffect(() => {
    setSearchValue(value);
  }, [value]);

  const itemToString = (item) => (item ? createSuggestionLabel(item, filterProps) : value); // if item is 'null', we should retain the current value

  const renderMenu = (closeMenu, inputValue, clearSelection, setState) => {
    if (loading) return <LoadingSuggestion />;

    if (!inputValue) {
      clearSelection();
      return null;
    }

    return suggestions.map((suggestion, i) =>
      RenderMenuSuggestion(onClickItem, filterProps, suggestion, closeMenu, setState, i)
    );
  };

  return (
    <Downshift
      id="google-places-ds"
      inputValue={searchValue}
      itemToString={itemToString}
      onInputValueChange={(v) => {
        setSearchValue(v);
        onInputChange(v);
      }}
    >
      {(downshift) => {
        const { getInputProps, getMenuProps, closeMenu, openMenu, isOpen, setState, inputValue, clearSelection } =
          downshift;

        const inputProps = getInputProps({
          onFocus: openMenu
        });

        return (
          <div>
            <FormElements.TextInput
              id="google-places-ds-input"
              label={label}
              placeholder={placeholder}
              variant={variant}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <img src="/static/icons/google_on_white.png" alt="google" />
                  </InputAdornment>
                ),
                ...inputProps
              }}
              styledProps={styledProps}
            />
            {isOpen && (
              <Paper elevation={2} {...getMenuProps()}>
                {renderMenu(closeMenu, inputValue, clearSelection, setState)}
              </Paper>
            )}
          </div>
        );
      }}
    </Downshift>
  );
}

GooglePlacesAutoComplete.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  variant: PropTypes.string,
  placeholder: PropTypes.string,
  loading: PropTypes.bool,
  suggestions: PropTypes.arrayOf(PropTypes.shape({})),
  filterProps: PropTypes.arrayOf(PropTypes.string),
  onInputChange: PropTypes.func.isRequired,
  onClickItem: PropTypes.func.isRequired,
  styledProps: PropTypes.shape({})
};
GooglePlacesAutoComplete.defaultProps = {
  value: PropTypes.string,
  name: 'location',
  label: 'Location',
  variant: 'outlined',
  placeholder: 'Search by Property, Location, Address, Point of Interest, ...',
  loading: false,
  suggestions: [],
  filterProps: ['label'],
  styledProps: {}
};
export default GooglePlacesAutoComplete;
